/**
 * Shared instrument desk — shell + Ant chassis.
 * Import chassis primitives for every new control. Do not fork a second kit.
 */

export {
  DeskShell,
  DeskSessionBar,
  DeskModule,
  DeskToolbar,
  DeskStatusRibbon,
  DeskChip,
  TradingLocalNav,
  deskShellStyles,
  type DeskShellProps,
  type DeskSessionBarProps,
  type DeskModuleProps,
  type DeskToolbarProps,
  type DeskStatusRibbonProps,
  type TradingLocalNavProps,
  type TradingLocalSegment,
} from './DeskShell'

export {
  ClientDeskSessionChrome,
  DeskConnectionBoundary,
} from './ClientDeskSessionChrome'

export {
  DeskChassis,
  DESK_EMPTY,
  DESK_CONTROL_SIZE,
  DeskButton,
  DeskInput,
  DeskInputNumber,
  DeskSelect,
  DeskSwitch,
  DeskSegmented,
  DeskTabs,
  DeskReadout,
  DeskReadoutRow,
  DeskSideChip,
  DeskStatus,
} from './chassis'
export type {
  DeskChassisProps,
  DeskReadoutProps,
  DeskReadoutRowProps,
  DeskReadoutTone,
  DeskReadoutEmphasis,
  DeskChipProps,
  DeskChipTone,
  DeskSide,
  DeskStatusProps,
} from './chassis'
